import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { horizontalSigningQueryKeys } from "./queryKeys"
import { useHorizontalSigningQuery } from "./useHorizontalSigningQueries"

export function useHorizontalSigningCampaignTable(parameters = {}, config = { enabled: true }) {
    const url = "horizontal_signs/table/"

    const { selectedNetwork } = useNetworksStateContext()

    const queryKey = horizontalSigningQueryKeys["table"]({ ...parameters, network: selectedNetwork?.slug })

    return useHorizontalSigningQuery(
        url,
        queryKey,
        parameters,
        config,
    )
}